// Presentation only: preserve server categories and never infer urgency from unread/important.
export const ACTIVITY_TYPES = Object.freeze([
  { id: "messages", label: "Messages", icon: "✉" },
  { id: "requests", label: "Demandes", icon: "⇄" },
  { id: "listings", label: "Annonces", icon: "⌑" },
  { id: "favorites", label: "Favoris et alertes", icon: "♡" },
  { id: "rewards", label: "Récompenses", icon: "✦" },
  { id: "security", label: "Sécurité", icon: "◇" },
  { id: "other", label: "Autres activités", icon: "◎" },
]);

export function activityType(item) {
  const event = String(item.eventType || item.event_type || "");
  const category = item.category;
  if (["account_security", "protection_moderation"].includes(category)) return "security";
  if (category === "saved_searches_alerts" || category === "search" || item.source === "matching" || /^(saved_search|favorite|selection)\./.test(event)) return "favorites";
  if (category === "messages_calls" || ["chat", "call"].includes(item.source) || category === "mentions") return "messages";
  if (category === "journeys_proposals" || ["friend", "group", "sortie"].includes(item.source)) return "requests";
  if (["marketplace_transactions", "market", "marketplace"].includes(category)) return "listings";
  if ((category === "wallet_rewards" || item.source === "wallet") && /point|reward|badge|level/.test(event)) return "rewards";
  return "other";
}

export function requiresAction(item) {
  if (item.available === false || item.isArchived || item.is_archived) return false;
  // Legacy invitations expose live accept/decline actions; historic event names alone do not prove a pending action.
  return item.actionRequired === true || item.action_required === true ||
    (item.actions || []).some((action) => ["accept-friend", "accept-group", "accept-sortie", "accept-call"].includes(action.id));
}

export function activityActionLabel(item) {
  if (item.category === "appointments_agenda") return "Voir le rendez-vous";
  if (item.category === "wallet_rewards") return activityType(item) === "rewards" ? "Voir la récompense" : "Voir le portefeuille";
  return {
    messages: "Ouvrir la conversation",
    requests: "Consulter la demande",
    listings: "Voir le détail",
    favorites: "Voir les résultats",
    rewards: "Voir la récompense",
    security: "Consulter l’alerte",
    other: "Consulter l’activité",
  }[activityType(item)];
}
